<template>

  <el-container id="main">

    <el-header id="nav">
      <div class="header-info">
        <div class="aside-header">击乐星空管理平台</div>
        <div class="header-left">
          <span>当前位置：</span> <span v-text="currentPage"></span>
          <a class="go-back" @click="goBack" v-if="goBackFlag">返回上一级</a>
        </div>
        <div class="header-right">
          <i class="el-icon-user"></i>
          <span v-text="userName">admin</span>
          <span> <el-button class="theme-btn" size="mini" type="primary" plain round @click="logOut">退出</el-button></span>
        </div>
      </div>
    </el-header>

    <el-container id="content" class="aside-main-container">
      <el-aside >
        <el-menu :default-openeds="['1','2','3','4']" :default-active="page_select" @select="handleSelect">
          <el-submenu index="1">
            <template slot="title"><i class="el-icon-office-building"></i>机构管理</template>
            <el-menu-item index="1-1">机构管理</el-menu-item>
            <!--<el-menu-item index="1-2">新增机构</el-menu-item>-->
          </el-submenu>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-menu"></i>类目管理</template>
            <el-menu-item index="2-1">类目管理</el-menu-item>
          </el-submenu>
          <el-submenu index="3">
            <template slot="title"><i class="el-icon-s-operation"></i>陪练管理</template>
            <el-menu-item index="3-1">内容管理</el-menu-item>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title"><i class="el-icon-setting"></i>信息管理</template>
            <el-menu-item index="4-2">资料修改</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main class="manage-main-container">
        <!--机构列表-->
        <organ-list @checkDetail="checkDetail" @showEdit="showEdit" @checkAddOrgan="checkAddOrgan" v-if="page_select==='1-1'"></organ-list>
        <!--机构详情-->
        <organ-detail :detail-id="detailId" v-if="checkDetailFlag"></organ-detail>
        <!--添加机构-->
        <add-organ v-if="editFlag||checkAddOrganFlag" :edit-flag="editFlag" :organ-id="detailId"></add-organ>
        <!--类目管理-->
        <category-manage v-if="page_select==='2-1'"></category-manage>

        <!--内容管理-->
        <!-- 添加父课程内容 -->
        <add-content v-if="showAddContentFlag && page_select==='3-1'"></add-content>
        <!--内容编辑、内容详情-->
        <content-detail v-else-if="(showContentDetailFlag || showContentEditFlag) && page_select==='3-1'" :content-id="contentDetailId"
          :show-content-edit-flag="showContentEditFlag" @goBack="goBack"></content-detail>
        <!-- 内容管理列表 -->
        <content-list
          @showAddContent="showAddContent"
          @showContentEdit="showContentEdit"
          @showContentDetail="showContentDetail"
          v-else-if="page_select==='3-1'"></content-list>

        <!--信息管理-->
        <info-modify v-if="page_select==='4-2'"></info-modify>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import OrganList from '../components/organManage/OrganList'
  import AddOrgan from '../components/organManage/AddOrgan'
  import OrganDetail from '../components/organManage/OrganDetail'
  import CategoryManage from '../components/categoryManage/CategoryManage'
  import ContentList from '../components/practiceManage/ContentList'
  import AddContent from '../components/practiceManage/AddContent'
  import ContentDetail from '../components/practiceManage/ContentDetail'
  import InfoModify from '../components/infoManage/InfoModify'

  export default {
    name: "Page_OrganManage",
    components: {
      "organ-list": OrganList,
      "add-organ": AddOrgan,
      "organ-detail": OrganDetail,
      "category-manage": CategoryManage,
      "content-list": ContentList,
      "info-modify": InfoModify,
      "add-content": AddContent,
      "content-detail": ContentDetail,
    },
    data() {
      return {
        page_select: '1-1',
        checkDetailFlag: false,
        editFlag: false,
        showAddContentFlag: false,
        showContentDetailFlag: false,
        showContentEditFlag: false,
        checkAddOrganFlag: false,

        // 机构详情
        detailId: null,

        // 内容详情
        contentDetailId: null,
        // 内容编辑
        contentEditId: '',

        // 当前页面 默认机构列表页
        currentPage: '机构管理',
        userName: '',

        //  返回上一级显示控制
        goBackFlag: false,
      }
    },

    created() {
      if (localStorage["associationProfile"]) {
        this.userName = JSON.parse(localStorage["associationProfile"]).name;
      }
      if (localStorage["parentPage"]) {
        console.log('localStorage["parentPage"]', localStorage["parentPage"]);
        this.$nextTick(() => {
          this.switchPage(localStorage["parentPage"]);
          this.handleSelect(localStorage['parentPage']);
        })
      }
    },
    methods: {
      // 退出
      logOut() {
        // 清理当前localStorage
        localStorage.removeItem("associationToken");
        localStorage.removeItem("associationProfile");
        localStorage.removeItem("parentPage");
        this.tools.pageRedirected('', '/login')
        // this.$api.post('/user/logout.json')
        //   .then(success=>{
        //     this.$message({
        //       message: '退出成功！',
        //       type: 'success'
        //     });
        //     this.tools.pageRedirected('','/')
        //   },err=>{
        //     this.$message.error(err.msg)
        //   }).catch(err=>{
        //   this.$message.error("退出异常！")
        // })
      },

      //返回上一级  二级页面显示
      goBack() {
        // 取消当前所有页面标记
        this.checkDetailFlag = false;
        this.showAddContentFlag = false;
        this.showContentEditFlag = false;
        this.editFlag = false;
        this.showContentDetailFlag = false;
        this.checkAddOrganFlag = false;
        // 显示当前二级页的一级页
        this.handleSelect(localStorage['parentPage']);
      },

      // 左侧导航选择
      handleSelect(key) {
        this.checkDetailFlag = false;
        this.showAddContentFlag = false;
        this.showContentEditFlag = false;
        this.editFlag = false;
        this.showContentDetailFlag = false;
        this.checkAddOrganFlag = false;

        // 取消返回上一级
        this.goBackFlag = false;
        this.page_select = key;

        // 记录当前一级页
        localStorage['parentPage'] = key;
        this.switchPage(key);
      },

      switchPage(key) {
        switch (key) {
          case '1-1':
            this.currentPage = '机构管理';
            break;
          case '2-1':
            this.currentPage = '类目管理';
            break;
          case '3-1':
            this.currentPage = '内容管理';
            break;
          case '4-2':
            this.currentPage = '信息管理';
            break;
        }
      },

      // 显示添加机构
      checkAddOrgan() {
        // 记录当前一级页
        // localStorage['parentPage'] = this.page_select;
        // 显示上一级
        this.goBackFlag = true;
        this.page_select = '';
        this.checkAddOrganFlag = true;
        this.currentPage = '机构管理-添加机构';
      },

      //  显示机构详情
      checkDetail(data) {
        // 记录当前一级页
        // localStorage['parentPage'] = this.page_select;
        // 显示上一级
        this.goBackFlag = true;
        this.page_select = '';
        this.detailId = data.id;
        this.editFlag = false;
        this.currentPage = '机构管理-机构详情';
        this.checkDetailFlag = true;
      },

      // 显示机构编辑
      showEdit(data) {
        // 记录当前一级页
        // localStorage['parentPage'] = this.page_select;
        // 显示上一级
        this.goBackFlag = true;
        this.page_select = '';
        this.currentPage = '机构管理-机构信息编辑';
        this.detailId = data.id;
        this.editFlag = true;
      },

      //  显示添加内容
      showAddContent() {
        // 记录当前一级页
        localStorage['parentPage'] = this.page_select;
        // 显示上一级
        this.goBackFlag = true;
        // this.page_select = '';
        this.currentPage = '内容管理-新增内容';
        this.contentEditId = '';
        this.showAddContentFlag = true;
      },

      showContentEdit(data) {
        // 记录当前一级页
        // localStorage['parentPage'] = this.page_select;
        // 显示上一级
        this.goBackFlag = true;
        // this.page_select = '';
        this.currentPage = '内容管理-编辑内容';
        this.contentDetailId = data.id;
        this.showContentEditFlag = true;
      },


      //  显示内容详情
      showContentDetail(data) {
        // 记录当前一级页
        localStorage['parentPage'] = this.page_select;
        // 显示上一级
        this.goBackFlag = true;
        // this.page_select = '';
        this.currentPage = '内容管理-内容详情';
        // 和内容详情公用一个id
        this.contentDetailId = data.id;
        this.showContentDetailFlag = true;
      },

    }
  }
</script>

<style scoped>
  #main {
    height: 100%;
  }
  #nav {
    width: 100%;
    height: 60px;
  }

  /*利用脱离文档流的方式（绝对定位）*/
  #content {
    width: 100%;
    position: absolute;
    top: 60px;
    bottom: 0;
    left: 0;
  }
  .el-container{
    display: flex;
    flex-direction: column;
    /*padding-bottom: 30px;*/
  }
  .aside-main-container{
    display: flex;
    flex-direction: row;
    background-color: #fff;
  }


  /*左边导航*/
  .aside-header {
    height: 60px;
    width: 250px;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    line-height: 60px;
  }

  /*菜单*/
  .el-aside{
    padding-top: 30px;
    padding-bottom: 30px;
    width: 250px !important;
  }
  .el-submenu{
    width: 250px !important;
    padding-left: 20px;
    padding-right: 30px;
  }
  .el-menu{
    border-right:0;
  }
  /* .el-menu-item{
    background-color: #f2f6f9;
  } */
  .el-menu-item.is-active{
    background-color: #f3cd04;
    color: #FFF;
  }
  .el-menu-item:hover{
    background-color: #f3cd04;
  }
  .aside-main-container>>>.el-submenu__title:hover{
    background-color: #f3cd04 ;
  }



    /*导航结束*/

  .el-header {
    background-color: #fff;
    color: #333;
    height: 60px;
    line-height: 60px;
    font-size: 12px;
    padding-left: 0;
  }

  .header-info {
    width: 100%;
    height: 100%;
    display: flex;
  }

  .header-left {
    text-align: left;
    padding-left: 10px;
    flex: 1;
    /*border-left: #fffed4 1px solid;*/
  }

  .header-right {
    margin-right: 30px;
    text-align: right;
    flex: 1;
  }

  .header-right > span {
    margin-left: 10px;

  }

  /*返回上一级*/
  .go-back {
    margin-left: 10px;
    color: #ff571a;
    cursor: pointer;
  }

  .manage-main-container {
    background: #f2f6f9;
  }

  .login-out{
    border: 0;
    color: #FFF;
    background-color: #f3cd04;
  }
  .login-out:hover{
    background-color: #f3cd04;
  }
  .login-out:visited{
    background-color: #f3cd04;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Page_Manage.vue